// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file supervisor/v1/environmentopts.proto (package supervisor.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnvironmentGitStatus, FileChange } from "../../gitpod/v1/environment_pb";
import { file_gitpod_v1_environment } from "../../gitpod/v1/environment_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file supervisor/v1/environmentopts.proto.
 */
export const file_supervisor_v1_environmentopts: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gitpod_v1_environment, file_google_protobuf_timestamp]);

/**
 * empty for now to allow for future expansion on GetGitStatus rpc
 *
 * @generated from message supervisor.v1.GetGitStatusRequest
 */
export type GetGitStatusRequest = Message<"supervisor.v1.GetGitStatusRequest"> & {
};

/**
 * Describes the message supervisor.v1.GetGitStatusRequest.
 * Use `create(GetGitStatusRequestSchema)` to create a new message.
 */
export const GetGitStatusRequestSchema: GenMessage<GetGitStatusRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 0);

/**
 * @generated from message supervisor.v1.GetGitStatusResponse
 */
export type GetGitStatusResponse = Message<"supervisor.v1.GetGitStatusResponse"> & {
  /**
   * @generated from field: gitpod.v1.EnvironmentGitStatus status = 1;
   */
  status?: EnvironmentGitStatus;
};

/**
 * Describes the message supervisor.v1.GetGitStatusResponse.
 * Use `create(GetGitStatusResponseSchema)` to create a new message.
 */
export const GetGitStatusResponseSchema: GenMessage<GetGitStatusResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 1);

/**
 * @generated from message supervisor.v1.GetGitDiffRequest
 */
export type GetGitDiffRequest = Message<"supervisor.v1.GetGitDiffRequest"> & {
  /**
   * path is the relative path of the file to get the diff for
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * this directly maps to the unified parameter (-U) of git diff
   * which controls the number of lines of context around a hunk
   *
   * @generated from field: int32 unified = 2;
   */
  unified: number;

  /**
   * base_ref is the git ref to diff against (e.g. "origin/main").
   * When empty, diffs against HEAD (uncommitted changes only).
   * When set, diffs from merge-base(base_ref, HEAD) to the working tree.
   *
   * @generated from field: string base_ref = 3;
   */
  baseRef: string;
};

/**
 * Describes the message supervisor.v1.GetGitDiffRequest.
 * Use `create(GetGitDiffRequestSchema)` to create a new message.
 */
export const GetGitDiffRequestSchema: GenMessage<GetGitDiffRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 2);

/**
 * @generated from message supervisor.v1.GetGitDiffResponse
 */
export type GetGitDiffResponse = Message<"supervisor.v1.GetGitDiffResponse"> & {
  /**
   * file_change is the current file change for the requested file at time of request
   *
   * @generated from field: gitpod.v1.FileChange file_change = 1;
   */
  fileChange?: FileChange;

  /**
   * hunks is the list of hunks for the requested file at time of request
   *
   * @generated from field: repeated supervisor.v1.GitHunk hunks = 2;
   */
  hunks: GitHunk[];

  /**
   * is_binary is true when the file is detected as binary (e.g. images, fonts).
   * When true, hunks will be empty.
   *
   * @generated from field: bool is_binary = 3;
   */
  isBinary: boolean;
};

/**
 * Describes the message supervisor.v1.GetGitDiffResponse.
 * Use `create(GetGitDiffResponseSchema)` to create a new message.
 */
export const GetGitDiffResponseSchema: GenMessage<GetGitDiffResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 3);

/**
 * @generated from message supervisor.v1.GitHunk
 */
export type GitHunk = Message<"supervisor.v1.GitHunk"> & {
  /**
   * starting line number in original file
   *
   * @generated from field: int32 original_start_line = 1;
   */
  originalStartLine: number;

  /**
   * number of lines the hunk applies to in the original file
   *
   * @generated from field: int32 original_lines = 2;
   */
  originalLines: number;

  /**
   * if > 0, then the original file had a 'No newline at end of file' mark at this offset
   *
   * @generated from field: int32 original_no_newline_at = 3;
   */
  originalNoNewlineAt: number;

  /**
   * starting line number in new file
   *
   * @generated from field: int32 new_start_line = 4;
   */
  newStartLine: number;

  /**
   * number of lines the hunk applies to in the new file
   *
   * @generated from field: int32 new_lines = 5;
   */
  newLines: number;

  /**
   * optional section heading
   *
   * @generated from field: string section = 6;
   */
  section: string;

  /**
   * 0-indexed line offset in unified file diff (including section headers); this is
   * only set when Hunks are read from entire file diff (i.e., when ReadAllHunks is
   * called) This accounts for hunk headers, too, so the StartPosition of the first
   * hunk will be 1.
   *
   * @generated from field: int32 start_position = 7;
   */
  startPosition: number;

  /**
   * hunk body (lines prefixed with '-', '+', or ' '
   *
   * @generated from field: string body = 8;
   */
  body: string;
};

/**
 * Describes the message supervisor.v1.GitHunk.
 * Use `create(GitHunkSchema)` to create a new message.
 */
export const GitHunkSchema: GenMessage<GitHunk> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 4);

/**
 * @generated from message supervisor.v1.GetFileDiffContentRequest
 */
export type GetFileDiffContentRequest = Message<"supervisor.v1.GetFileDiffContentRequest"> & {
  /**
   * path is the relative path of the file to get content for
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * include_binary_content, when true, instructs the server to return
   * original_content and new_content even for binary files. By default
   * binary files only set is_binary without content to avoid unnecessary reads.
   *
   * @generated from field: bool include_binary_content = 2;
   */
  includeBinaryContent: boolean;

  /**
   * base_ref is the git ref to diff against (e.g. "origin/main").
   * When empty, original_content comes from HEAD (uncommitted changes only).
   * When set, original_content comes from merge-base(base_ref, HEAD).
   *
   * @generated from field: string base_ref = 3;
   */
  baseRef: string;
};

/**
 * Describes the message supervisor.v1.GetFileDiffContentRequest.
 * Use `create(GetFileDiffContentRequestSchema)` to create a new message.
 */
export const GetFileDiffContentRequestSchema: GenMessage<GetFileDiffContentRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 5);

/**
 * @generated from message supervisor.v1.GetFileDiffContentResponse
 */
export type GetFileDiffContentResponse = Message<"supervisor.v1.GetFileDiffContentResponse"> & {
  /**
   * file_change describes the type of change (added, modified, deleted, etc.)
   *
   * @generated from field: gitpod.v1.FileChange file_change = 1;
   */
  fileChange?: FileChange;

  /**
   * original_content is the file content from HEAD/index (empty for new files)
   *
   * @generated from field: bytes original_content = 2;
   */
  originalContent: Uint8Array;

  /**
   * new_content is the current working tree content (empty for deleted files)
   *
   * @generated from field: bytes new_content = 3;
   */
  newContent: Uint8Array;

  /**
   * is_binary is true when the file is detected as binary (e.g. images, fonts).
   * When include_binary_content is not set, original_content and new_content
   * will be empty for binary files.
   *
   * @generated from field: bool is_binary = 4;
   */
  isBinary: boolean;
};

/**
 * Describes the message supervisor.v1.GetFileDiffContentResponse.
 * Use `create(GetFileDiffContentResponseSchema)` to create a new message.
 */
export const GetFileDiffContentResponseSchema: GenMessage<GetFileDiffContentResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 6);

/**
 * @generated from message supervisor.v1.GetGitDiffFilesRequest
 */
export type GetGitDiffFilesRequest = Message<"supervisor.v1.GetGitDiffFilesRequest"> & {
  /**
   * base_ref is the git ref to diff against (e.g. "origin/main").
   * When empty, defaults to HEAD and returns uncommitted changes
   * (equivalent to GetGitStatus changed_files).
   * When set, returns all files changed between merge-base(base_ref, HEAD)
   * and the current working tree (committed + uncommitted).
   *
   * @generated from field: string base_ref = 1;
   */
  baseRef: string;
};

/**
 * Describes the message supervisor.v1.GetGitDiffFilesRequest.
 * Use `create(GetGitDiffFilesRequestSchema)` to create a new message.
 */
export const GetGitDiffFilesRequestSchema: GenMessage<GetGitDiffFilesRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 7);

/**
 * @generated from message supervisor.v1.GetGitDiffFilesResponse
 */
export type GetGitDiffFilesResponse = Message<"supervisor.v1.GetGitDiffFilesResponse"> & {
  /**
   * changed_files is the list of files that differ between the base ref
   * and the current working tree.
   *
   * @generated from field: repeated gitpod.v1.FileChange changed_files = 1;
   */
  changedFiles: FileChange[];

  /**
   * total_changed_files is the total count of changed files.
   *
   * @generated from field: int32 total_changed_files = 2;
   */
  totalChangedFiles: number;
};

/**
 * Describes the message supervisor.v1.GetGitDiffFilesResponse.
 * Use `create(GetGitDiffFilesResponseSchema)` to create a new message.
 */
export const GetGitDiffFilesResponseSchema: GenMessage<GetGitDiffFilesResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 8);

/**
 * @generated from message supervisor.v1.GetDefaultBranchRequest
 */
export type GetDefaultBranchRequest = Message<"supervisor.v1.GetDefaultBranchRequest"> & {
};

/**
 * Describes the message supervisor.v1.GetDefaultBranchRequest.
 * Use `create(GetDefaultBranchRequestSchema)` to create a new message.
 */
export const GetDefaultBranchRequestSchema: GenMessage<GetDefaultBranchRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 9);

/**
 * @generated from message supervisor.v1.GetDefaultBranchResponse
 */
export type GetDefaultBranchResponse = Message<"supervisor.v1.GetDefaultBranchResponse"> & {
  /**
   * branch is the name of the default branch (e.g. "main").
   *
   * @generated from field: string branch = 1;
   */
  branch: string;
};

/**
 * Describes the message supervisor.v1.GetDefaultBranchResponse.
 * Use `create(GetDefaultBranchResponseSchema)` to create a new message.
 */
export const GetDefaultBranchResponseSchema: GenMessage<GetDefaultBranchResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 10);

/**
 * FindRequest specifies criteria for finding files and directories.
 * The response is limited to 65536 entries maximum.
 *
 * @generated from message supervisor.v1.FindRequest
 */
export type FindRequest = Message<"supervisor.v1.FindRequest"> & {
  /**
   * path is the starting directory for the search.
   * Absolute paths (starting with /) resolve to filesystem root.
   * Relative paths resolve relative to the workspace folder.
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * pattern is a glob pattern to match file/directory names
   *
   * @generated from field: string pattern = 2;
   */
  pattern: string;

  /**
   * type filters results by file type
   *
   * @generated from field: supervisor.v1.FindRequest.FileType type = 3;
   */
  type: FindRequest_FileType;

  /**
   * max_depth limits how deep to search (0 = unlimited)
   *
   * @generated from field: int32 max_depth = 4;
   */
  maxDepth: number;

  /**
   * fuzzy enables fuzzy matching for the pattern field.
   * When true, pattern is matched using fuzzy substring matching
   * against relative file paths instead of glob matching against filenames.
   * Default: false (glob matching).
   *
   * @generated from field: bool fuzzy = 5;
   */
  fuzzy: boolean;
};

/**
 * Describes the message supervisor.v1.FindRequest.
 * Use `create(FindRequestSchema)` to create a new message.
 */
export const FindRequestSchema: GenMessage<FindRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 11);

/**
 * @generated from enum supervisor.v1.FindRequest.FileType
 */
export enum FindRequest_FileType {
  /**
   * @generated from enum value: FILE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILE_TYPE_FILE = 1;
   */
  FILE = 1,

  /**
   * @generated from enum value: FILE_TYPE_DIRECTORY = 2;
   */
  DIRECTORY = 2,

  /**
   * @generated from enum value: FILE_TYPE_ANY = 3;
   */
  ANY = 3,
}

/**
 * Describes the enum supervisor.v1.FindRequest.FileType.
 */
export const FindRequest_FileTypeSchema: GenEnum<FindRequest_FileType> = /*@__PURE__*/
  enumDesc(file_supervisor_v1_environmentopts, 11, 0);

/**
 * @generated from message supervisor.v1.FindResponse
 */
export type FindResponse = Message<"supervisor.v1.FindResponse"> & {
  /**
   * files contains matching entries, limited to 65536 maximum.
   * If truncated is true, more entries exist but were not returned.
   *
   * @generated from field: repeated supervisor.v1.FileInfo files = 1;
   */
  files: FileInfo[];

  /**
   * truncated indicates the result was limited due to exceeding 65536 entries
   *
   * @generated from field: bool truncated = 2;
   */
  truncated: boolean;
};

/**
 * Describes the message supervisor.v1.FindResponse.
 * Use `create(FindResponseSchema)` to create a new message.
 */
export const FindResponseSchema: GenMessage<FindResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 12);

/**
 * @generated from message supervisor.v1.FileInfo
 */
export type FileInfo = Message<"supervisor.v1.FileInfo"> & {
  /**
   * path is the absolute path
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * is_directory indicates if this is a directory
   *
   * @generated from field: bool is_directory = 2;
   */
  isDirectory: boolean;

  /**
   * size is the file size in bytes (0 for directories)
   *
   * @generated from field: int64 size = 3;
   */
  size: bigint;
};

/**
 * Describes the message supervisor.v1.FileInfo.
 * Use `create(FileInfoSchema)` to create a new message.
 */
export const FileInfoSchema: GenMessage<FileInfo> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 13);

/**
 * ReadFileRequest reads file content or lists directory entries
 *
 * @generated from message supervisor.v1.ReadFileRequest
 */
export type ReadFileRequest = Message<"supervisor.v1.ReadFileRequest"> & {
  /**
   * path is the path to the file or directory.
   * Absolute paths (starting with /) resolve to filesystem root.
   * Relative paths resolve relative to the workspace folder.
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * offset is the byte offset to start reading from (ignored for directories)
   *
   * @generated from field: int64 offset = 2;
   */
  offset: bigint;

  /**
   * length is the maximum number of bytes to read (0 = read all, ignored for directories)
   *
   * @generated from field: int64 length = 3;
   */
  length: bigint;
};

/**
 * Describes the message supervisor.v1.ReadFileRequest.
 * Use `create(ReadFileRequestSchema)` to create a new message.
 */
export const ReadFileRequestSchema: GenMessage<ReadFileRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 14);

/**
 * @generated from message supervisor.v1.ReadFileResponse
 */
export type ReadFileResponse = Message<"supervisor.v1.ReadFileResponse"> & {
  /**
   * @generated from oneof supervisor.v1.ReadFileResponse.result
   */
  result: {
    /**
     * content is returned when reading a file
     *
     * @generated from field: supervisor.v1.FileContent content = 1;
     */
    value: FileContent;
    case: "content";
  } | {
    /**
     * directory is returned when path is a directory
     *
     * @generated from field: supervisor.v1.DirectoryListing directory = 2;
     */
    value: DirectoryListing;
    case: "directory";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message supervisor.v1.ReadFileResponse.
 * Use `create(ReadFileResponseSchema)` to create a new message.
 */
export const ReadFileResponseSchema: GenMessage<ReadFileResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 15);

/**
 * @generated from message supervisor.v1.FileContent
 */
export type FileContent = Message<"supervisor.v1.FileContent"> & {
  /**
   * data is the file content
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * total_size is the total file size in bytes
   *
   * @generated from field: int64 total_size = 2;
   */
  totalSize: bigint;

  /**
   * content_hash is the SHA-256 hash of the returned data (hex encoded)
   *
   * @generated from field: string content_hash = 3;
   */
  contentHash: string;
};

/**
 * Describes the message supervisor.v1.FileContent.
 * Use `create(FileContentSchema)` to create a new message.
 */
export const FileContentSchema: GenMessage<FileContent> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 16);

/**
 * @generated from message supervisor.v1.DirectoryListing
 */
export type DirectoryListing = Message<"supervisor.v1.DirectoryListing"> & {
  /**
   * @generated from field: repeated supervisor.v1.FileInfo entries = 1;
   */
  entries: FileInfo[];
};

/**
 * Describes the message supervisor.v1.DirectoryListing.
 * Use `create(DirectoryListingSchema)` to create a new message.
 */
export const DirectoryListingSchema: GenMessage<DirectoryListing> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 17);

/**
 * WriteFileRequest writes content to a file
 *
 * @generated from message supervisor.v1.WriteFileRequest
 */
export type WriteFileRequest = Message<"supervisor.v1.WriteFileRequest"> & {
  /**
   * path is the path to the file.
   * Absolute paths (starting with /) resolve to filesystem root.
   * Relative paths resolve relative to the workspace folder.
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * content is the data to write
   *
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;

  /**
   * mode specifies how to handle existing files
   *
   * @generated from field: supervisor.v1.WriteMode mode = 3;
   */
  mode: WriteMode;
};

/**
 * Describes the message supervisor.v1.WriteFileRequest.
 * Use `create(WriteFileRequestSchema)` to create a new message.
 */
export const WriteFileRequestSchema: GenMessage<WriteFileRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 18);

/**
 * @generated from message supervisor.v1.WriteFileResponse
 */
export type WriteFileResponse = Message<"supervisor.v1.WriteFileResponse"> & {
  /**
   * bytes_written is the number of bytes written
   *
   * @generated from field: int64 bytes_written = 1;
   */
  bytesWritten: bigint;
};

/**
 * Describes the message supervisor.v1.WriteFileResponse.
 * Use `create(WriteFileResponseSchema)` to create a new message.
 */
export const WriteFileResponseSchema: GenMessage<WriteFileResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 19);

/**
 * @generated from message supervisor.v1.CreateTerminalRequest
 */
export type CreateTerminalRequest = Message<"supervisor.v1.CreateTerminalRequest"> & {
  /**
   * shell is the shell to use (e.g., "/bin/bash"). If empty, uses the user's default shell.
   *
   * @generated from field: string shell = 1;
   */
  shell: string;

  /**
   * working_directory is the initial working directory. If empty, uses the workspace folder.
   *
   * @generated from field: string working_directory = 2;
   */
  workingDirectory: string;

  /**
   * initial_cols is the initial number of columns (default: 80)
   *
   * @generated from field: uint32 initial_cols = 3;
   */
  initialCols: number;

  /**
   * initial_rows is the initial number of rows (default: 24)
   *
   * @generated from field: uint32 initial_rows = 4;
   */
  initialRows: number;

  /**
   * env is additional environment variables to set
   *
   * @generated from field: map<string, string> env = 5;
   */
  env: { [key: string]: string };

  /**
   * annotations are arbitrary key-value metadata stored on the terminal.
   * Agents use "ona.com/owner" = "agent" to mark terminals they own.
   *
   * @generated from field: map<string, string> annotations = 6;
   */
  annotations: { [key: string]: string };
};

/**
 * Describes the message supervisor.v1.CreateTerminalRequest.
 * Use `create(CreateTerminalRequestSchema)` to create a new message.
 */
export const CreateTerminalRequestSchema: GenMessage<CreateTerminalRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 20);

/**
 * @generated from message supervisor.v1.CreateTerminalResponse
 */
export type CreateTerminalResponse = Message<"supervisor.v1.CreateTerminalResponse"> & {
  /**
   * terminal_id is the unique identifier for the created terminal
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId: string;
};

/**
 * Describes the message supervisor.v1.CreateTerminalResponse.
 * Use `create(CreateTerminalResponseSchema)` to create a new message.
 */
export const CreateTerminalResponseSchema: GenMessage<CreateTerminalResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 21);

/**
 * @generated from message supervisor.v1.ReadTerminalRequest
 */
export type ReadTerminalRequest = Message<"supervisor.v1.ReadTerminalRequest"> & {
  /**
   * terminal_id is the terminal to read from
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId: string;

  /**
   * skip_history, when true, skips sending the scrollback buffer.
   * Use on reconnection to avoid duplicate content.
   *
   * @generated from field: bool skip_history = 2;
   */
  skipHistory: boolean;
};

/**
 * Describes the message supervisor.v1.ReadTerminalRequest.
 * Use `create(ReadTerminalRequestSchema)` to create a new message.
 */
export const ReadTerminalRequestSchema: GenMessage<ReadTerminalRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 22);

/**
 * @generated from message supervisor.v1.ReadTerminalResponse
 */
export type ReadTerminalResponse = Message<"supervisor.v1.ReadTerminalResponse"> & {
  /**
   * data is the terminal output
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message supervisor.v1.ReadTerminalResponse.
 * Use `create(ReadTerminalResponseSchema)` to create a new message.
 */
export const ReadTerminalResponseSchema: GenMessage<ReadTerminalResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 23);

/**
 * @generated from message supervisor.v1.WriteTerminalRequest
 */
export type WriteTerminalRequest = Message<"supervisor.v1.WriteTerminalRequest"> & {
  /**
   * terminal_id is the terminal to write to
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId: string;

  /**
   * data is the input to send to the terminal
   *
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message supervisor.v1.WriteTerminalRequest.
 * Use `create(WriteTerminalRequestSchema)` to create a new message.
 */
export const WriteTerminalRequestSchema: GenMessage<WriteTerminalRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 24);

/**
 * @generated from message supervisor.v1.WriteTerminalResponse
 */
export type WriteTerminalResponse = Message<"supervisor.v1.WriteTerminalResponse"> & {
};

/**
 * Describes the message supervisor.v1.WriteTerminalResponse.
 * Use `create(WriteTerminalResponseSchema)` to create a new message.
 */
export const WriteTerminalResponseSchema: GenMessage<WriteTerminalResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 25);

/**
 * @generated from message supervisor.v1.ResizeTerminalRequest
 */
export type ResizeTerminalRequest = Message<"supervisor.v1.ResizeTerminalRequest"> & {
  /**
   * terminal_id is the terminal to resize
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId: string;

  /**
   * cols is the new number of columns
   *
   * @generated from field: uint32 cols = 2;
   */
  cols: number;

  /**
   * rows is the new number of rows
   *
   * @generated from field: uint32 rows = 3;
   */
  rows: number;
};

/**
 * Describes the message supervisor.v1.ResizeTerminalRequest.
 * Use `create(ResizeTerminalRequestSchema)` to create a new message.
 */
export const ResizeTerminalRequestSchema: GenMessage<ResizeTerminalRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 26);

/**
 * @generated from message supervisor.v1.ResizeTerminalResponse
 */
export type ResizeTerminalResponse = Message<"supervisor.v1.ResizeTerminalResponse"> & {
};

/**
 * Describes the message supervisor.v1.ResizeTerminalResponse.
 * Use `create(ResizeTerminalResponseSchema)` to create a new message.
 */
export const ResizeTerminalResponseSchema: GenMessage<ResizeTerminalResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 27);

/**
 * @generated from message supervisor.v1.CloseTerminalRequest
 */
export type CloseTerminalRequest = Message<"supervisor.v1.CloseTerminalRequest"> & {
  /**
   * terminal_id is the terminal to close
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId: string;
};

/**
 * Describes the message supervisor.v1.CloseTerminalRequest.
 * Use `create(CloseTerminalRequestSchema)` to create a new message.
 */
export const CloseTerminalRequestSchema: GenMessage<CloseTerminalRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 28);

/**
 * @generated from message supervisor.v1.CloseTerminalResponse
 */
export type CloseTerminalResponse = Message<"supervisor.v1.CloseTerminalResponse"> & {
};

/**
 * Describes the message supervisor.v1.CloseTerminalResponse.
 * Use `create(CloseTerminalResponseSchema)` to create a new message.
 */
export const CloseTerminalResponseSchema: GenMessage<CloseTerminalResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 29);

/**
 * @generated from message supervisor.v1.ListTerminalsRequest
 */
export type ListTerminalsRequest = Message<"supervisor.v1.ListTerminalsRequest"> & {
};

/**
 * Describes the message supervisor.v1.ListTerminalsRequest.
 * Use `create(ListTerminalsRequestSchema)` to create a new message.
 */
export const ListTerminalsRequestSchema: GenMessage<ListTerminalsRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 30);

/**
 * @generated from message supervisor.v1.ListTerminalsResponse
 */
export type ListTerminalsResponse = Message<"supervisor.v1.ListTerminalsResponse"> & {
  /**
   * @generated from field: repeated supervisor.v1.TerminalInfo terminals = 1;
   */
  terminals: TerminalInfo[];
};

/**
 * Describes the message supervisor.v1.ListTerminalsResponse.
 * Use `create(ListTerminalsResponseSchema)` to create a new message.
 */
export const ListTerminalsResponseSchema: GenMessage<ListTerminalsResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 31);

/**
 * @generated from message supervisor.v1.TerminalInfo
 */
export type TerminalInfo = Message<"supervisor.v1.TerminalInfo"> & {
  /**
   * terminal_id is the unique identifier
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId: string;

  /**
   * shell is the shell being used
   *
   * @generated from field: string shell = 2;
   */
  shell: string;

  /**
   * working_directory is the current working directory
   *
   * @generated from field: string working_directory = 3;
   */
  workingDirectory: string;

  /**
   * cols is the current number of columns
   *
   * @generated from field: uint32 cols = 4;
   */
  cols: number;

  /**
   * rows is the current number of rows
   *
   * @generated from field: uint32 rows = 5;
   */
  rows: number;

  /**
   * created_at is when the terminal was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * annotations are arbitrary key-value metadata set at creation time.
   *
   * @generated from field: map<string, string> annotations = 7;
   */
  annotations: { [key: string]: string };
};

/**
 * Describes the message supervisor.v1.TerminalInfo.
 * Use `create(TerminalInfoSchema)` to create a new message.
 */
export const TerminalInfoSchema: GenMessage<TerminalInfo> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 32);

/**
 * @generated from message supervisor.v1.ExecRequest
 */
export type ExecRequest = Message<"supervisor.v1.ExecRequest"> & {
  /**
   * operation_id is the idempotency key (typically tool_call_id from LLM)
   * Same ID returns cached result if operation completed
   *
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * command is the shell command to execute (run via sh -c)
   *
   * @generated from field: string command = 2;
   */
  command: string;

  /**
   * working_directory (optional, defaults to workspace folder)
   *
   * @generated from field: string working_directory = 3;
   */
  workingDirectory: string;

  /**
   * timeout_seconds for command execution (default: 120, 0 = no timeout)
   *
   * @generated from field: int32 timeout_seconds = 4;
   */
  timeoutSeconds: number;
};

/**
 * Describes the message supervisor.v1.ExecRequest.
 * Use `create(ExecRequestSchema)` to create a new message.
 */
export const ExecRequestSchema: GenMessage<ExecRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 33);

/**
 * @generated from message supervisor.v1.ExecResponse
 */
export type ExecResponse = Message<"supervisor.v1.ExecResponse"> & {
  /**
   * exit_code of the command (0 = success)
   *
   * @generated from field: int32 exit_code = 1;
   */
  exitCode: number;

  /**
   * stdout output
   *
   * @generated from field: string stdout = 2;
   */
  stdout: string;

  /**
   * stderr output
   *
   * @generated from field: string stderr = 3;
   */
  stderr: string;
};

/**
 * Describes the message supervisor.v1.ExecResponse.
 * Use `create(ExecResponseSchema)` to create a new message.
 */
export const ExecResponseSchema: GenMessage<ExecResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 34);

/**
 * @generated from message supervisor.v1.CancelExecRequest
 */
export type CancelExecRequest = Message<"supervisor.v1.CancelExecRequest"> & {
  /**
   * operation_id of the operation to cancel
   *
   * @generated from field: string operation_id = 1;
   */
  operationId: string;
};

/**
 * Describes the message supervisor.v1.CancelExecRequest.
 * Use `create(CancelExecRequestSchema)` to create a new message.
 */
export const CancelExecRequestSchema: GenMessage<CancelExecRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 35);

/**
 * Empty - cancellation is fire-and-forget
 * If operation was running, it's now cancelled
 * If already done or not found, no-op
 *
 * @generated from message supervisor.v1.CancelExecResponse
 */
export type CancelExecResponse = Message<"supervisor.v1.CancelExecResponse"> & {
};

/**
 * Describes the message supervisor.v1.CancelExecResponse.
 * Use `create(CancelExecResponseSchema)` to create a new message.
 */
export const CancelExecResponseSchema: GenMessage<CancelExecResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 36);

/**
 * @generated from message supervisor.v1.AttachTerminalRequest
 */
export type AttachTerminalRequest = Message<"supervisor.v1.AttachTerminalRequest"> & {
  /**
   * terminal_id is the terminal to attach to
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId: string;
};

/**
 * Describes the message supervisor.v1.AttachTerminalRequest.
 * Use `create(AttachTerminalRequestSchema)` to create a new message.
 */
export const AttachTerminalRequestSchema: GenMessage<AttachTerminalRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 37);

/**
 * @generated from message supervisor.v1.AttachTerminalResponse
 */
export type AttachTerminalResponse = Message<"supervisor.v1.AttachTerminalResponse"> & {
  /**
   * @generated from oneof supervisor.v1.AttachTerminalResponse.content
   */
  content: {
    /**
     * @generated from field: supervisor.v1.TerminalReplay replay = 1;
     */
    value: TerminalReplay;
    case: "replay";
  } | {
    /**
     * @generated from field: supervisor.v1.TerminalData data = 2;
     */
    value: TerminalData;
    case: "data";
  } | {
    /**
     * @generated from field: supervisor.v1.TerminalExited exited = 3;
     */
    value: TerminalExited;
    case: "exited";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message supervisor.v1.AttachTerminalResponse.
 * Use `create(AttachTerminalResponseSchema)` to create a new message.
 */
export const AttachTerminalResponseSchema: GenMessage<AttachTerminalResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 38);

/**
 * TerminalReplay contains the terminal replay data
 *
 * @generated from message supervisor.v1.TerminalReplay
 */
export type TerminalReplay = Message<"supervisor.v1.TerminalReplay"> & {
  /**
   * data is the terminal replay output
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: uint32 cols = 2;
   */
  cols: number;

  /**
   * @generated from field: uint32 rows = 3;
   */
  rows: number;
};

/**
 * Describes the message supervisor.v1.TerminalReplay.
 * Use `create(TerminalReplaySchema)` to create a new message.
 */
export const TerminalReplaySchema: GenMessage<TerminalReplay> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 39);

/**
 * TerminalData contains a terminal output
 *
 * @generated from message supervisor.v1.TerminalData
 */
export type TerminalData = Message<"supervisor.v1.TerminalData"> & {
  /**
   * data is the terminal output
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message supervisor.v1.TerminalData.
 * Use `create(TerminalDataSchema)` to create a new message.
 */
export const TerminalDataSchema: GenMessage<TerminalData> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 40);

/**
 * TerminalExited indicates the terminal process has exited.
 *
 * @generated from message supervisor.v1.TerminalExited
 */
export type TerminalExited = Message<"supervisor.v1.TerminalExited"> & {
  /**
   * @generated from field: int32 exit_code = 1;
   */
  exitCode: number;
};

/**
 * Describes the message supervisor.v1.TerminalExited.
 * Use `create(TerminalExitedSchema)` to create a new message.
 */
export const TerminalExitedSchema: GenMessage<TerminalExited> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 41);

/**
 * @generated from message supervisor.v1.WatchRequest
 */
export type WatchRequest = Message<"supervisor.v1.WatchRequest"> & {
  /**
   * Event types to subscribe to. If empty, all event types are delivered.
   *
   * @generated from field: repeated supervisor.v1.WatchEventType event_types = 1;
   */
  eventTypes: WatchEventType[];

  /**
   * Additional glob patterns to exclude from file events (on top of .gitignore).
   * Only applies to FILE_CHANGE events.
   *
   * @generated from field: repeated string file_exclude_patterns = 2;
   */
  fileExcludePatterns: string[];
};

/**
 * Describes the message supervisor.v1.WatchRequest.
 * Use `create(WatchRequestSchema)` to create a new message.
 */
export const WatchRequestSchema: GenMessage<WatchRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 42);

/**
 * @generated from message supervisor.v1.WatchResponse
 */
export type WatchResponse = Message<"supervisor.v1.WatchResponse"> & {
  /**
   * @generated from oneof supervisor.v1.WatchResponse.event
   */
  event: {
    /**
     * File system change events (batched).
     *
     * @generated from field: supervisor.v1.FileChangeEvents file_changes = 1;
     */
    value: FileChangeEvents;
    case: "fileChanges";
  } | {
    /**
     * Git status has changed — client should refetch GetGitStatus.
     *
     * @generated from field: supervisor.v1.GitStatusChanged git_status_changed = 2;
     */
    value: GitStatusChanged;
    case: "gitStatusChanged";
  } | {
    /**
     * Overflow: too many events or a re-scan occurred.
     * Client should refetch all relevant state.
     *
     * @generated from field: supervisor.v1.WatchOverflow overflow = 3;
     */
    value: WatchOverflow;
    case: "overflow";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message supervisor.v1.WatchResponse.
 * Use `create(WatchResponseSchema)` to create a new message.
 */
export const WatchResponseSchema: GenMessage<WatchResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 43);

/**
 * FileChangeEvents is a batch of file system change events.
 *
 * @generated from message supervisor.v1.FileChangeEvents
 */
export type FileChangeEvents = Message<"supervisor.v1.FileChangeEvents"> & {
  /**
   * @generated from field: repeated supervisor.v1.FileChangeEvent events = 1;
   */
  events: FileChangeEvent[];
};

/**
 * Describes the message supervisor.v1.FileChangeEvents.
 * Use `create(FileChangeEventsSchema)` to create a new message.
 */
export const FileChangeEventsSchema: GenMessage<FileChangeEvents> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 44);

/**
 * FileChangeEvent represents a single file system change.
 *
 * @generated from message supervisor.v1.FileChangeEvent
 */
export type FileChangeEvent = Message<"supervisor.v1.FileChangeEvent"> & {
  /**
   * Relative path from the workspace folder root.
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: supervisor.v1.FileChangeType type = 2;
   */
  type: FileChangeType;

  /**
   * True if the path is a directory.
   *
   * @generated from field: bool is_directory = 3;
   */
  isDirectory: boolean;
};

/**
 * Describes the message supervisor.v1.FileChangeEvent.
 * Use `create(FileChangeEventSchema)` to create a new message.
 */
export const FileChangeEventSchema: GenMessage<FileChangeEvent> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 45);

/**
 * GitStatusChanged signals that git status has changed (new/modified/deleted
 * tracked files, branch change, etc.). No payload — this is a notification.
 *
 * @generated from message supervisor.v1.GitStatusChanged
 */
export type GitStatusChanged = Message<"supervisor.v1.GitStatusChanged"> & {
};

/**
 * Describes the message supervisor.v1.GitStatusChanged.
 * Use `create(GitStatusChangedSchema)` to create a new message.
 */
export const GitStatusChangedSchema: GenMessage<GitStatusChanged> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 46);

/**
 * @generated from message supervisor.v1.ListTerminalProfilesRequest
 */
export type ListTerminalProfilesRequest = Message<"supervisor.v1.ListTerminalProfilesRequest"> & {
  /**
   * include_detected_profiles controls whether shells from /etc/shells are
   * auto-detected. When false only config_profiles are returned.
   *
   * @generated from field: bool include_detected_profiles = 1;
   */
  includeDetectedProfiles: boolean;

  /**
   * config_profiles are user-configured terminal profiles keyed by display name.
   * These take precedence over auto-detected profiles from /etc/shells, which
   * often includes irrelevant entries (rbash, dash, sh, etc.).
   * A profile with an empty path disables the detected profile of the same name.
   *
   * @generated from field: map<string, supervisor.v1.ConfigTerminalProfile> config_profiles = 2;
   */
  configProfiles: { [key: string]: ConfigTerminalProfile };
};

/**
 * Describes the message supervisor.v1.ListTerminalProfilesRequest.
 * Use `create(ListTerminalProfilesRequestSchema)` to create a new message.
 */
export const ListTerminalProfilesRequestSchema: GenMessage<ListTerminalProfilesRequest> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 47);

/**
 * ConfigTerminalProfile is a user-configured terminal profile entry.
 * Using a message instead of a scalar allows fields to be added later
 * (e.g. args, env, icon) without breaking existing callers.
 *
 * @generated from message supervisor.v1.ConfigTerminalProfile
 */
export type ConfigTerminalProfile = Message<"supervisor.v1.ConfigTerminalProfile"> & {
  /**
   * path is the absolute path to the shell executable.
   * Empty string means the profile is explicitly disabled.
   *
   * @generated from field: string path = 1;
   */
  path: string;
};

/**
 * Describes the message supervisor.v1.ConfigTerminalProfile.
 * Use `create(ConfigTerminalProfileSchema)` to create a new message.
 */
export const ConfigTerminalProfileSchema: GenMessage<ConfigTerminalProfile> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 48);

/**
 * @generated from message supervisor.v1.ListTerminalProfilesResponse
 */
export type ListTerminalProfilesResponse = Message<"supervisor.v1.ListTerminalProfilesResponse"> & {
  /**
   * @generated from field: repeated supervisor.v1.TerminalProfile profiles = 1;
   */
  profiles: TerminalProfile[];
};

/**
 * Describes the message supervisor.v1.ListTerminalProfilesResponse.
 * Use `create(ListTerminalProfilesResponseSchema)` to create a new message.
 */
export const ListTerminalProfilesResponseSchema: GenMessage<ListTerminalProfilesResponse> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 49);

/**
 * TerminalProfile describes a shell profile available inside the devcontainer.
 *
 * @generated from message supervisor.v1.TerminalProfile
 */
export type TerminalProfile = Message<"supervisor.v1.TerminalProfile"> & {
  /**
   * profile_name is the display name (e.g. "bash", "zsh", "bash (2)").
   * Duplicate basenames from /etc/shells are disambiguated with a numeric suffix.
   *
   * @generated from field: string profile_name = 1;
   */
  profileName: string;

  /**
   * path is the absolute, validated path to the shell executable.
   *
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * is_auto_detected is true when the profile originates from /etc/shells
   * auto-detection, and false when it comes from the caller-supplied
   * config_profiles map.
   *
   * @generated from field: bool is_auto_detected = 3;
   */
  isAutoDetected: boolean;
};

/**
 * Describes the message supervisor.v1.TerminalProfile.
 * Use `create(TerminalProfileSchema)` to create a new message.
 */
export const TerminalProfileSchema: GenMessage<TerminalProfile> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 50);

/**
 * WatchOverflow signals that the watcher experienced an overflow or re-scan.
 * The client should refetch all file listings and git status.
 *
 * @generated from message supervisor.v1.WatchOverflow
 */
export type WatchOverflow = Message<"supervisor.v1.WatchOverflow"> & {
  /**
   * Human-readable reason for the overflow.
   *
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message supervisor.v1.WatchOverflow.
 * Use `create(WatchOverflowSchema)` to create a new message.
 */
export const WatchOverflowSchema: GenMessage<WatchOverflow> = /*@__PURE__*/
  messageDesc(file_supervisor_v1_environmentopts, 51);

/**
 * WriteMode specifies how WriteFile handles existing files
 *
 * @generated from enum supervisor.v1.WriteMode
 */
export enum WriteMode {
  /**
   * WRITE_MODE_UNSPECIFIED defaults to CREATE_OR_TRUNCATE
   *
   * @generated from enum value: WRITE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * WRITE_MODE_CREATE fails if the file already exists
   *
   * @generated from enum value: WRITE_MODE_CREATE = 1;
   */
  CREATE = 1,

  /**
   * WRITE_MODE_TRUNCATE overwrites the file, fails if it doesn't exist
   *
   * @generated from enum value: WRITE_MODE_TRUNCATE = 2;
   */
  TRUNCATE = 2,

  /**
   * WRITE_MODE_CREATE_OR_TRUNCATE creates or overwrites the file
   *
   * @generated from enum value: WRITE_MODE_CREATE_OR_TRUNCATE = 3;
   */
  CREATE_OR_TRUNCATE = 3,

  /**
   * WRITE_MODE_APPEND appends to the file, fails if it doesn't exist
   *
   * @generated from enum value: WRITE_MODE_APPEND = 4;
   */
  APPEND = 4,
}

/**
 * Describes the enum supervisor.v1.WriteMode.
 */
export const WriteModeSchema: GenEnum<WriteMode> = /*@__PURE__*/
  enumDesc(file_supervisor_v1_environmentopts, 0);

/**
 * WatchEventType specifies which event types a Watch client wants to receive.
 *
 * @generated from enum supervisor.v1.WatchEventType
 */
export enum WatchEventType {
  /**
   * @generated from enum value: WATCH_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WATCH_EVENT_TYPE_FILE_CHANGE = 1;
   */
  FILE_CHANGE = 1,

  /**
   * @generated from enum value: WATCH_EVENT_TYPE_GIT_STATUS = 2;
   */
  GIT_STATUS = 2,
}

/**
 * Describes the enum supervisor.v1.WatchEventType.
 */
export const WatchEventTypeSchema: GenEnum<WatchEventType> = /*@__PURE__*/
  enumDesc(file_supervisor_v1_environmentopts, 1);

/**
 * FileChangeType describes the kind of file system change.
 *
 * @generated from enum supervisor.v1.FileChangeType
 */
export enum FileChangeType {
  /**
   * @generated from enum value: FILE_CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILE_CHANGE_TYPE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: FILE_CHANGE_TYPE_UPDATED = 2;
   */
  UPDATED = 2,

  /**
   * @generated from enum value: FILE_CHANGE_TYPE_DELETED = 3;
   */
  DELETED = 3,
}

/**
 * Describes the enum supervisor.v1.FileChangeType.
 */
export const FileChangeTypeSchema: GenEnum<FileChangeType> = /*@__PURE__*/
  enumDesc(file_supervisor_v1_environmentopts, 2);

/**
 * @generated from service supervisor.v1.EnvironmentOpsService
 */
export const EnvironmentOpsService: GenService<{
  /**
   * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitStatus
   */
  getGitStatus: {
    methodKind: "unary";
    input: typeof GetGitStatusRequestSchema;
    output: typeof GetGitStatusResponseSchema;
  },
  /**
   * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitDiff
   */
  getGitDiff: {
    methodKind: "unary";
    input: typeof GetGitDiffRequestSchema;
    output: typeof GetGitDiffResponseSchema;
  },
  /**
   * GetFileDiffContent returns the original and new file content for client-side diffing.
   * This allows the frontend to compute diffs without relying on pre-parsed hunks.
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.GetFileDiffContent
   */
  getFileDiffContent: {
    methodKind: "unary";
    input: typeof GetFileDiffContentRequestSchema;
    output: typeof GetFileDiffContentResponseSchema;
  },
  /**
   * GetGitDiffFiles returns the list of files that differ between a base ref and the
   * current working tree. Use this to discover which files to request diffs for via
   * GetGitDiff or GetFileDiffContent.
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitDiffFiles
   */
  getGitDiffFiles: {
    methodKind: "unary";
    input: typeof GetGitDiffFilesRequestSchema;
    output: typeof GetGitDiffFilesResponseSchema;
  },
  /**
   * GetDefaultBranch returns the name of the default branch (e.g. "main").
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.GetDefaultBranch
   */
  getDefaultBranch: {
    methodKind: "unary";
    input: typeof GetDefaultBranchRequestSchema;
    output: typeof GetDefaultBranchResponseSchema;
  },
  /**
   * Find searches for files and directories matching the given criteria
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.Find
   */
  find: {
    methodKind: "unary";
    input: typeof FindRequestSchema;
    output: typeof FindResponseSchema;
  },
  /**
   * ReadFile reads file content or lists directory entries
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.ReadFile
   */
  readFile: {
    methodKind: "unary";
    input: typeof ReadFileRequestSchema;
    output: typeof ReadFileResponseSchema;
  },
  /**
   * WriteFile writes content to a file
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.WriteFile
   */
  writeFile: {
    methodKind: "unary";
    input: typeof WriteFileRequestSchema;
    output: typeof WriteFileResponseSchema;
  },
  /**
   * CreateTerminal creates a new terminal session
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.CreateTerminal
   */
  createTerminal: {
    methodKind: "unary";
    input: typeof CreateTerminalRequestSchema;
    output: typeof CreateTerminalResponseSchema;
  },
  /**
   * ReadTerminal streams terminal output to the client.
   * Multiple clients can read from the same terminal concurrently.
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.ReadTerminal
   */
  readTerminal: {
    methodKind: "server_streaming";
    input: typeof ReadTerminalRequestSchema;
    output: typeof ReadTerminalResponseSchema;
  },
  /**
   * WriteTerminal sends input to a terminal
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.WriteTerminal
   */
  writeTerminal: {
    methodKind: "unary";
    input: typeof WriteTerminalRequestSchema;
    output: typeof WriteTerminalResponseSchema;
  },
  /**
   * ResizeTerminal updates terminal dimensions
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.ResizeTerminal
   */
  resizeTerminal: {
    methodKind: "unary";
    input: typeof ResizeTerminalRequestSchema;
    output: typeof ResizeTerminalResponseSchema;
  },
  /**
   * CloseTerminal destroys a terminal session
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.CloseTerminal
   */
  closeTerminal: {
    methodKind: "unary";
    input: typeof CloseTerminalRequestSchema;
    output: typeof CloseTerminalResponseSchema;
  },
  /**
   * ListTerminals returns all active terminal sessions
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.ListTerminals
   */
  listTerminals: {
    methodKind: "unary";
    input: typeof ListTerminalsRequestSchema;
    output: typeof ListTerminalsResponseSchema;
  },
  /**
   * AttachTerminal streams terminal buffer state to the client.
   * The first message is always a TerminalSnapshot containing the full buffer.
   * Subsequent messages are TerminalDiffs with incremental updates.
   * If the client detects a version gap, it should re-attach to get a fresh snapshot.
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.AttachTerminal
   */
  attachTerminal: {
    methodKind: "server_streaming";
    input: typeof AttachTerminalRequestSchema;
    output: typeof AttachTerminalResponseSchema;
  },
  /**
   * Exec executes a command in the environment.
   * - Idempotent: same operation_id returns cached result if completed
   * - Durable: survives caller disconnection, results stored on filesystem
   * - Blocking: waits for completion
   * - Context cancellation is treated as transient (operation continues)
   * - Use CancelExec for explicit user cancellation
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.Exec
   */
  exec: {
    methodKind: "unary";
    input: typeof ExecRequestSchema;
    output: typeof ExecResponseSchema;
  },
  /**
   * CancelExec explicitly cancels an operation (user intent to stop)
   * Fire-and-forget: no error if operation not found or already completed
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.CancelExec
   */
  cancelExec: {
    methodKind: "unary";
    input: typeof CancelExecRequestSchema;
    output: typeof CancelExecResponseSchema;
  },
  /**
   * Watch streams workspace events to the client. Events are batched and
   * coalesced to reduce noise. The client can filter which event types
   * it wants to receive.
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.Watch
   */
  watch: {
    methodKind: "server_streaming";
    input: typeof WatchRequestSchema;
    output: typeof WatchResponseSchema;
  },
  /**
   * ListTerminalProfiles returns all available shell profiles detected from
   * /etc/shells on the host system.
   *
   * @generated from rpc supervisor.v1.EnvironmentOpsService.ListTerminalProfiles
   */
  listTerminalProfiles: {
    methodKind: "unary";
    input: typeof ListTerminalProfilesRequestSchema;
    output: typeof ListTerminalProfilesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_supervisor_v1_environmentopts, 0);

